import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'
import moment from 'moment'

import at from 'lodash/at'
import get from 'lodash/get'

import IssueWorkOrderForm from '../../components/issues/issue-work-order-form'

import { getIssue, sendIssueToBacklog, sendIssueToWorkOrder } from '../../actions/issues'
import { loadWorkOrdersForLocation } from '../../actions/work-orders'

function mapStateToProps (state, ownProps) {
  const issue = state.issues[ownProps.params.issueId]

  if (!issue) return { loading: true }

  const pagination = get(state, `pagination.workOrdersByLocation.${issue.location}`, {})
  const workOrders = at(state.workOrders, pagination.ids || [])

  return { issue, workOrders }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(getIssue(ownProps.params.issueId))
    .then((action) => {
      const locationId = action.payload.entities.issues[action.payload.result].location

      dispatch(loadWorkOrdersForLocation(locationId))
    })

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      let action

      if (data.workOrderType === "backlog") {
        data.timezone = moment.tz.guess()
        action = sendIssueToBacklog
      } else {
        action = sendIssueToWorkOrder
      }

      dispatch(action(ownProps.params.issueId, data))
        .then(() => dispatch(goBack()))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueWorkOrderForm)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-work-order-form-container.js